import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberAbbrevation',
  standalone: false,
})
export class NumberAbbreviationPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null || value === undefined) {
      return '0'; 
    }

    if (value < 1000) {
      return value.toString();
    }

    if (value >= 1000 && value < 1_000_000) {
  
      return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}k`;
    }

    if (value >= 1_000_000) {
    
      return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, '')}m`;
    }

    return value.toString(); 
  }
}
